<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >ETAPAS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card class="pa-3" v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            v-show="$can('etapas.create|admin.loja')"
            @click="novo()"
            color="topEnviados"
            dark
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsEtapa"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.chk_ativo="{ item }">
          <v-switch
            dense
            color="green"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo, 'chk_ativo')"
            v-show="$can('montagem_etapa.update|admin.loja')"
            v-model="item.chk_ativo"
            true-value="T"
            false-value="F"
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            v-show="$can('etapas.update|admin.loja')"
            @click="editEtapa(item)"
            >edit</v-icon
          >
          <!---<v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|etapas.delete')"
            @click="deleteEtapa(item)"
            >delete</v-icon
          >-->
        </template>
      
        <template v-slot:item.vincular_item="{ item }">
          <v-icon
            color="green"
            class="mr-2"
            v-show="$can('montagem_etapa.update|admin.loja')"
            @click="vincularItem(item)"
            >link</v-icon
          >
        </template>
        <template v-slot:item.vincular_cardapio="{ item }">
          <v-icon
            color="green"
            class="mr-2"
            v-show="$can('montagem_etapa.update|admin.loja')"
            @click="vincularCardapio(item)"
            >link</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCadastro" max-width="35%">
      <v-card>
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Etapa</span>
          <span v-if="cadastro == false">Editar Etapa</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" md="8" lg="8">
              <v-text-field
                v-model="etapa.nome"
                label="Nome"
                filled
                dense
                clearable
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" lg="8">
              <v-text-field
                v-model="etapa.descricao"
                label="Descrição"
                filled
                dense
                clearable
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" lg="4">
             
              <v-text-field
                  v-model="etapa.ordem"
                  label="Ordem"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <v-autocomplete
                :auto-select-first="true"
                v-model="etapa.min_escolha"
                ref="id"
                label="Escolher no Mínimo"
                :items="lista_min_escolha"
                filled
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="5" lg="4">
              <v-autocomplete
                :auto-select-first="true"
                v-model="etapa.max_escolha"
                ref="id"
                label="Escolher no Máximo"
                :items="lista_max_escolha"
                filled
              ></v-autocomplete>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVinculaProduto" max-width="35%">
      <v-card>
        <v-card-title class>
          <span>Adicional</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" md="12" lg="12" sd="12" xs="12">
              <v-autocomplete
                dense
                chips
                small-chips
                deletable-chips
                label="Produtos vinculados"
                :loading="carregandoVincullos"
                :auto-select-first="true"
                v-model="produtos"
                item-value="codigo"
                item-text="descricao_reduzida"
                ref="codigo_produto"
                :items="itemsProdutos"
                @change="gravarVinculoItemProduto()"
                filled
              >
              </v-autocomplete>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaProduto = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVinculaCardapio" persistent max-width="35%">
      <v-card>
        <v-card-title class>
          <span>Vincular Cardapios</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" md="12" lg="12" sd="12" xs="12">
              <v-autocomplete
                dense
                chips
                small-chips
                label="Cardápio vinculados"
                multiple
                :auto-select-first="true"
                v-model="cardapios"
                item-value="id"
                item-text="descricao"
                ref="cardapio"
                :items="itemsCardapio"
                @change="gravarVinculoCardapio()"
                filled
              ></v-autocomplete>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaCardapio = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa etapa?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCancelItem" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa item?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancelItem = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deletaItem(selItemEtapa)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogVinculaItem" persistent max-width="65%">
      <v-card>
        <v-card-title class>
          <span>Vincular Item </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xl="6" md="6" lg="4" sd="4" xs="12">
                <v-autocomplete
                  dense
                  label="Itens"
                  :auto-select-first="true"
                  v-model="item.id"
                  item-value="id"
                  item-text="descricao"
                  ref="id_item"
                  :items="items"
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="2" md="2" lg="2" sd="1" xs="12">
                <v-text-field
                 
                  v-model="item.ordem"
                  label="Ordem"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="2" md="3" lg="3" sd="3" xs="12">
                <v-btn v-if="!editItem" color="success" x-large @click="gravarVinculoItem()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn v-if="editItem" dark color="orange" x-large @click="editarVinculoItem()">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn v-if="editItem" color="error" x-large @click="cancelaEditarItem()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="12" md="12" lg="12" sd="12" xs="12">
              
                <v-data-table
                  :headers="headersItemEtapa"
                  :items="listaItensEtapa"
                  :loading="loading_table_item"
                  :footerProps="footerProps"
                  loading-text="Carregando... Aguarde"
                  dense
                  :search="search"
                  no-data-text="Nenhum resultado encontrado!"
                  no-results-text="Nenhum resultado encontrado!"
                  class="elevation-1"
                >
                <template v-slot:item.vincular_item="{ item }">
                  <v-icon
                    color="green"
                    class="mr-2"
                    v-show="true"
                    @click="vincularProduto(item)"
                    >link</v-icon
                  >
                </template>
                
                <template v-slot:item.editar="{ item }">
                  <v-icon
                    color="btBlue"
                    class="mr-2"
                    v-show="$can('etapas.update|admin.loja')"
                    @click="editItemEtapa(item)"
                    >edit</v-icon
          >
                  </template>
                  <template v-slot:item.chk_default="{ item }">
                    <v-switch
                      dense
                      color="green"
                      :label="`${checkStatus(item.chk_default)}`"
                      @change="
                        mudarPadrao(
                          item.id,
                          item.chk_default,
                          'chk_default',
                          item.qtde_sel
                        )
                      "
                      v-model="item.chk_default"
                      true-value="T"
                      false-value="F"
                    ></v-switch>
                  </template>
                  <template v-slot:item.chk_ativo="{ item }">
                    <v-switch
                      dense
                      color="green"
                      :label="`${checkStatusSN(item.chk_ativo)}`"
                      @change="
                        mudarPadrao(
                          item.id,
                          item.chk_ativo,
                          'chk_ativo',
                          0
                        )
                      "
                      v-model="item.chk_ativo"
                      true-value="T"
                      false-value="F"
                    ></v-switch>
                  </template>
                  <template v-slot:item.chk_unico="{ item }">
                    <v-switch
                      dense
                      color="green"
                      :label="`${checkStatusSN(item.chk_unico)}`"
                      @change="
                        mudarPadrao(
                          item.id,
                          item.chk_unico,
                          'chk_unico',
                          item.qtde_sel_unico
                        )
                      "
                      v-model="item.chk_unico"
                      true-value="T"
                      
                      false-value="F"
                    ></v-switch>
                  </template>
                  <!--<template v-slot:item.action="{ item }">
                    <v-icon
                      color="error"
                      class="mr-2"
                      v-show="$can('admin.loja|etapas.delete')"
                      @click="deleteItemEtapa(item)"
                      >delete</v-icon
                    >
                  </template>-->
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaItem = false;fecharDialogVinculoItem()">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarItem()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      :color="sucesso"
      bottom
      elevation="4"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
    </v-snackbar>

    <v-snackbar
      :timeout="3000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
      <!--<v-btn block dark @click.native="snackbarError = false">Fechar</v-btn>-->
    </v-snackbar>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    editItem: false,
    dialogCancelItem: false,
    itemsVinculadosEtapa: [],
    loading_table_item: false,
    cadastro: true,
    dialogVinculaItem: false,
    snackbarSuccess: false,
    snackbarError: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    sucesso: "botao_sucesso",
    error: "error",
    footerProps: { "items-per-page-options": [30, 50, 100] },
    singleLine: true,
    lista_ordem: [],

    lista_min_escolha: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

    lista_max_escolha: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

    etapa: {
      nome: "",
      descricao: "",
      ordem: "",
      min_escolha: "",
      max_escolha: "",
    },
    item: {
      id: null,
      id_item: null,
      ordem: null,
    },
    max_escolha: null,
    carregandoVincullos:false,
    autoUpdate: true,
    selItemEtapa: null,
    isUpdating: false,
    imageFile: [],
    file: "",
    files: "",
    cardapios: null,
    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsEtapa: [],
    produtos: null,
    selectEtapa: "",
    dialogVinculaProduto: false,
    dialogVinculaCardapio: false,
    itemsProdutos: [],
    itemsCardapio: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
    items: null,
    selectItem: null,
    listaItensEtapa: [],
    item_lista_ordem: null,
    headersItemEtapa: [
      {
        text: "Ordem",
        align: "left",
        value: "ordem",
        width: "8%",
      },
      {
        text: "Item",
        value: "descricao",
        sortable: true,
        align: "left",
        width: "30%",
      },
      {
        text: "Editar",
        value: "editar",
        sortable: true,
        align: "right",
        width: "10%",
      },
      {
        text: "Adicional",
        value: "vincular_item",
        sortable: true,
        align: "right",
        width: "10%",
      },
      {
        text: "Padrão",
        value: "chk_default",
        sortable: true,
        align: "left",
        width: "10%",
      },
      {
        text: "Ativo",
        value: "chk_ativo",
        sortable: true,
        align: "left",
        width: "10%",
      },
      {
        text: "Único",
        value: "chk_unico",
        sortable: true,
        align: "left",
        width: "10%",
      },
      
    ],
    headers: [
      {
        text: "etapa",
        value: "descricao",
        sortable: true,
        align: "left",
        width: "25%",
      },
      {
        text: "Ordem",
        value: "ordem",
        sortable: true,
        align: "left",
        width: "6%",
      },
      {
        text: "Status",
        value: "chk_ativo",
        sortable: true,
        align: "left",
        width: "8%",
      },
      {
        text: "Min. Escolha",
        value: "min_escolha",
        sortable: true,
        align: "left",
        width: "8%",
      },
      {
        text: "Max. Escolha",
        value: "max_escolha",
        sortable: true,
        align: "left",
        width: "8%",
      },
      
      {
        text: "Vincular Item",
        value: "vincular_item",
        sortable: true,
        align: "left",
        width: "8%",
      },
      {
        text: "Vincular Cardápio",
        value: "vincular_cardapio",
        sortable: true,
        align: "left",
        width: "10%",
      },
      {
        text: "Ação",
        width: "15%",
        align: "right",
        value: "action",
        sortable: false,
      },
    ],
  }),
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  mounted() {
    this.etapas();
    this.buscaProdutos();
    this.BuscaCardapios();
    this.BuscaItens();
  },
  methods: {
    fecharDialogVinculoItem(){
      this.limpaCamposEditarItem()
     
    },
    cancelaEditarItem() {
      this.limpaCamposEditarItem()
    },
    limpaCamposEditarItem() {
      this.item.id = null;
      this.item.ordem = null;
      this.item.id_item = null;
      this.editItem = false;
    },
    gravarVinculoItemProduto() {
      var formData = new FormData();

      formData.append("produtos", this.produtos);
      formData.append("id_etapa_item", this.selectCardapio);
      formData.append("id_etapa", this.selectItem);

      axios
        .post(`/montagem/item_etapa/add_produto`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
          
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    mudarStatus(id, status, tipo) {
      axios
        .post(`/montagem/etapa/mudar_status`, {
          id: id,
          status: status,
          tipo: tipo,
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            //this.cardapios();
          }
        });
    },
    async mudarPadrao(id, status, tipo, qtde_sel) {
      if (status != "F") {
        if (qtde_sel >= this.max_escolha) {
          this.textSnack = "Limite atingido";
          this.snackbarError = true;
          this.BuscaItensVinculados();
          return false;
        }
      }

      await axios
        .post(`/montagem/item_etapa/mudar_padrao`, {
          id: id,
          status: status,
          tipo: tipo,
          id_etapa: this.selectItem
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Alterado com sucesso!";
            this.BuscaItensVinculados();
          }
        });
    },
    checkStatus(valor) {
      if (valor == "T") {
        return "Ativo";
      } else {
        return "Inativo";
      }
    },
    checkStatusSN(valor) {
      if (valor == "T") {
        return "Sim";
      } else {
        return "Não";
      }
    },

    async editarVinculoItem() {
      var formData = new FormData();

      formData.append("id_etapa", this.item.id_etapa);
      formData.append("id_item", this.item.id);
      formData.append("id", this.item.id_item);
      formData.append("ordem", this.item.ordem);

      await axios
        .post(`/montagem/item_etapa/editar`, formData)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.BuscaItensVinculados();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
      this.item.ordem = null;
      this.item.id_item = null;
      this.item.id = null;
    },
    async gravarVinculoItem() {
      var formData = new FormData();

      formData.append("id_etapa", this.selectItem);
      formData.append("id_item", this.item.id);
      formData.append("ordem", this.item.ordem);

      await axios
        .post(`/montagem/item_etapa`, formData)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.BuscaItensVinculados();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
      this.item.ordem = null;
      this.item.id_item = null;
      this.item.id = null;
    },
    async BuscaItensVinculados() {
      this.loading_table_item = true;
      var dados = [];
      this.listaItensEtapa = []
     await axios
        .get(`/montagem/item_etapa/lista/` + this.selectItem)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.loading_table_item = false;
            this.listaItensEtapa = response.data;
            dados = response.data;
            this.item_lista_ordem = response.data[0].lista_ordem;
            this.item.ordem = response.data[0].ordem_selected;
            //console.log("lista"+this.listaItensEtapa[0].lista_ordem)
          }
        });
          this.listaItensEtapa = dados;
    },
    BuscaItens() {
      this.loading_table = true;
      axios.get(`/montagem/item/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          //  this.loading_table = false;
          this.items = response.data;
        }
      });
    },
    buscaProdutos() {
      axios.get(`/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
    BuscaCardapios() {
      this.loading_table = true;
      axios.get(`/montagem/lista_cardapios`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCardapio = response.data;
        }
      });
    },
    gravarVinculoCardapio() {
      var formData = new FormData();

      formData.append("cardapios", this.cardapios);
      formData.append("id_etapa", this.selectCardapio);

      axios
        .post(`/montagem/etapa_cardapio`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            // this.limpaCampos();
            // this.dialogCadastro = false;
            // this.cardapios();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },

   
    gravarVinculo() {
      var formData = new FormData();

      formData.append("produtos", this.produtos);
      formData.append("id_etapa", this.selectCardapio);

      axios
        .post(`/montagem/etapa_produto`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            // this.limpaCampos();
            // this.dialogCadastro = false;
            // this.cardapios();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    vinculadosCardapio() {
      axios
        .get(`/montagem/etapa/cardapio_vinculado/` + this.selectCardapio)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.cardapios = response.data;
          }
        });
    },
    vinculados() {
      this.carregandoVincullos = true;
      axios
        .get(`/montagem/item_etapa/produto_vinculado/${this.selectItem}/${this.selectCardapio}`)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
            this.carregandoVincullos = false;
          } else {  
            this.produtos = response.data;
            this.carregandoVincullos = false;
          }
        });
    },
    vincularProduto(item) {
      this.dialogVinculaProduto = true;
      this.selectCardapio = item.id;

      this.vinculados();
    },
    vincularCardapio(item) {
      this.dialogVinculaCardapio = true;
      this.selectCardapio = item.id;

      this.vinculadosCardapio();
    },
    vincularItem(item) {
      this.item.ordem = null;
      this.item.id_item = null;
      this.dialogVinculaItem = true;
      this.selectItem = item.id;
      this.max_escolha = item.max_escolha;
        setTimeout(() => (
        this.BuscaItensVinculados()
      )      
      , 700);
     
      // this.vinculados()
    },
    remove(item) {
      const index = this.catSel.indexOf(item.name);
      if (index >= 0) this.catSel.splice(index, 1);
    },
    novo() {
      this.dialogCadastro = true;
         const maiorOrdem = Math.max(...this.itemsEtapa.map(etapa => etapa.ordem));
      this.etapa.ordem = maiorOrdem +1 ;
         
      this.limpaCampos();
      console.log(
        document.getElementsByClassName("v-file-input--text").innerHtml
      );
    },
    limpaCampos() {
      this.cadastro = true;
      this.etapa.descricao = "";
      this.etapa.nome = "";
      this.etapa.min_escolha = "";
      this.etapa.max_escolha = "";

      this.catSel = "";
    },
    fecharDialog() {},
    editItemEtapa(item){
      //this.item.id = item.id;
      this.editItem = true;
      this.item.id = item.id_item;
      this.item.id_item = item.id;
      this.item.ordem = item.ordem;
      this.item.id_etapa = item.id_etapa;
    },
    editEtapa(item) {
      this.dialogCadastro = true;
      this.cadastro = false;
      this.itemEdit = item.id;
      this.etapa.id = item.id;
      this.etapa.descricao = item.descricao;
      this.etapa.nome = item.nome;
      this.etapa.ordem = item.ordem;
      this.etapa.min_escolha = item.min_escolha;
      this.etapa.max_escolha = item.max_escolha;
    },
    deleteEtapa(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },
    deleteItemEtapa(item) {
      this.selItemEtapa = item.id;
      this.dialogCancelItem = true;
    },
    deleta() {
      axios.delete(`montagem/etapa/` + this.selItem).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarError = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = response.data.msg;
          this.dialogCancel = false;
          this.etapas();
        }
      });
    },
    deletaItem() {
      axios
        .delete(
          `montagem/item_etapa/` + this.selItemEtapa + "/" + this.selectItem
        )
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbarError = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.dialogCancelItem = false;
            this.BuscaItensVinculados();
          }
        });
    },

    etapas() {
      this.loading_table = true;
      this.etapa_lista_ordem = 1;
      axios.get(`montagem/etapa/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsEtapa = response.data;
         // this.etapa_lista_ordem = response.data[0].lista_ordem;
        //  this.etapa.ordem = response.data[0].ordem_selected;
        }
      });
    },
    gravar() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      var formData = new FormData();

      formData.append("ordem", this.etapa.ordem);
      formData.append("min_escolha", this.etapa.min_escolha);
      formData.append("max_escolha", this.etapa.max_escolha);
      //formData.append("codigo_img", this.catSel);
      formData.append("nome", this.etapa.nome);
      formData.append("descricao", this.etapa.descricao);

      axios
        .post(`montagem/etapa`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            //this.etapa.descricao = "";
            //this.etapa.ordem = "";

            this.novo();
            this.etapas();
          }
        })
        .catch((e) => {
          if (e.response.data != undefined) {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbarError = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbarError = true;
            }
          }
        });
    },
    gravarEdicao() {
      //   let config = { headers: { "Content-Type": 'multipart/form-data' } };
      var formData = new FormData();

      formData.append("id", this.etapa.id);
      formData.append("ordem", this.etapa.ordem);
      formData.append("min_escolha", this.etapa.min_escolha);
      formData.append("max_escolha", this.etapa.max_escolha);
      //formData.append("codigo_img", this.catSel);
      formData.append("nome", this.etapa.nome);
      formData.append("descricao", this.etapa.descricao);

      axios
        .post(`montagem/etapa/editar`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.limpaCampos();
            this.dialogCadastro = false;
            this.etapas();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true; 
          }
        });
    },

    buscaProdutos() {
      axios.get(`/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>
